import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCart } from "lucide-react";
import { CAPCUT } from "../../config";

export const CapCutSticky = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 550);
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50"
          data-testid="capcut-sticky-bar"
        >
          <div className="rounded-2xl bg-white border border-slate-200 shadow-[0_16px_50px_rgba(15,23,42,0.18)] px-4 py-3 md:px-5 flex items-center gap-4">
            <div className="min-w-0">
              <p className="font-capcut-heading font-bold text-sm text-slate-900 leading-tight whitespace-nowrap">CapCut Pro 1 Bulan</p>
              <p className="text-xs text-slate-500 whitespace-nowrap">{CAPCUT.pricePromoLabel} • proses instan</p>
            </div>
            <button
              onClick={() => (window.location.href = CAPCUT.checkoutUrl)}
              data-testid="capcut-sticky-cta"
              className="shrink-0 inline-flex items-center gap-2 rounded-full bg-blue-600 hover:bg-blue-700 text-white font-bold text-sm px-5 py-2.5 shadow-[0_4px_14px_0_rgb(37,99,235,0.39)] hover:scale-105 transition-[transform,background-color] duration-300 whitespace-nowrap"
            >
              <ShoppingCart className="w-4 h-4" /> Beli Sekarang
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
